module.exports = __webpack_public_path__ + "img/platform.1190e2ee.jpg";